import React from "react";

const MembershipProgressBar = ({ levels, currentPoints }) => {
  const totalLevels = levels.length;
  const currentTierIndex = levels.findIndex((level, index) => {
    const next = levels[index + 1];
    return next
      ? currentPoints >= level.pointAmount && currentPoints < next.pointAmount
      : currentPoints >= level.pointAmount;
  });
  const getProgressWidth:any = () => {
    const current = levels[currentTierIndex];
    const next = levels[currentTierIndex + 1];
    if (!next) return "100%";

    const range = next?.pointAmount - current?.pointAmount;
    const passed = currentPoints - current?.pointAmount;
    const percent = (passed / range) * (100 / (levels.length - 1));
    return `${currentTierIndex * (100 / (levels.length - 1)) + percent}%`;
  };

  return (
    <div className="w-full max-w-6xl mx-auto px-4">
      {/* Tiers display */}
      <div className="flex justify-between items-end mb-6">
        {levels.map((level, index) => {
          const isReached = currentPoints >= level.pointAmount;

          return (
            <div key={index} className="flex flex-col items-center text-center w-14 sm:w-20">
              <div
                className={`w-14 h-14 sm:w-20 sm:h-20 flex items-center justify-center rounded-xl mb-2 ${
                  isReached ? "bg-blue-100 border-2 border-blue-500" : "bg-gray-100"
                }`}
              >
                <img src={level.logo} alt={level.name} />
              </div>
              <span className="text-xs font-medium">{level.name}</span>
              <span className="text-xs text-gray-500">{level.pointAmount} pts</span>
            </div>
          );
        })}
      </div>
      <div className="relative h-3 bg-gray-300 rounded-full">
        <div
          className="absolute h-3 bg-blue-500 rounded-full transition-all duration-500"
          style={{ width: getProgressWidth() }}
        ></div>
        <div className="absolute top-1/2 left-0 w-full flex justify-between -translate-y-1/2">
          {levels.map((level, index) => {
            const isReached = currentPoints >= level.pointAmount;
            return (
              <div
                key={index}
                className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                  isReached ? "bg-blue-500 border-blue-500 text-white" : "bg-white border-gray-400"
                }`}
              >
                {isReached ? "✓" : ""}
              </div>
            );
          })}
        </div>
      </div>

      <p className="text-xs text-center mt-3 text-gray-600">
        Redeeming points won’t affect your progress to the next level
      </p>
    </div>
  );
};

export default MembershipProgressBar;
